import { buildFailedToPublishObject } from '../../unpublished-messages/operators/buildFailedToPublishObject';
import { FAILED } from '../constants/statusTypes';
import { getId, getMessageSendFailure, getMessageSendFailureRetryable, getStatusForCmf, getTimestamp
// @ts-ignore module not typed
} from './commonMessageFormatGetters';
// @ts-ignore module not typed
import { isCommonMessageFormat } from './cmfComparators';
export function wrapFailedMessageAsObject({
  allowRetry = true,
  channel,
  threadId
}) {
  return message => {
    if (!isCommonMessageFormat(message) || getStatusForCmf(message) !== FAILED) {
      return message;
    }
    const commonMessage = message;
    const isMessageRetryable = !getMessageSendFailure(commonMessage) || Boolean(getMessageSendFailureRetryable(commonMessage));
    return buildFailedToPublishObject({
      allowRetry: allowRetry && isMessageRetryable,
      channel,
      genericChannelId: commonMessage.genericChannelId || null,
      id: getId(commonMessage),
      message: commonMessage,
      threadId,
      timestamp: getTimestamp(commonMessage)
    });
  };
}